import React, {useEffect, useRef, useState} from 'react';

import validate from '../validators/validateNumberMultiple';
import QuestionNumber from './QuestionNumber';

const QuestionFormNumberMultiple = ({
  focus,
  question,
  savedAnswer,
  onChange,
  children,
}) => {
  const ref = useRef(null)
  const { options, allowDecimals, minValue, maxValue, unitPrefix, unitPostfix } = question;
  const initialStateMap = savedAnswer || {};
  const [stateMap, setStateMap] = useState(initialStateMap);

  const handleChange = (key, value) => {
    const list = {
      ...stateMap,
      ...{
        [key]: value
      }
    }
    setStateMap(s => ({ ...s, [key]: value }));
    const values = options.reduce((total, current) => {
      total[current.key] = list[current.key];
      return total;
    }, {});
    onChange(question.key, list, validate, values);
  };

  return (
    <div>
      {Object.entries(options).map(([index, option]) => (
        <QuestionNumber
          key={index}
          option={option}
          answer={stateMap[option.key]}
          minValue={option.minValue || minValue}
          maxValue={option.maxValue || maxValue}
          unitPrefix={option.unitPrefix || unitPrefix}
          unitPostfix={option.unitPostfix || unitPostfix}
          allowDecimals={option.allowDecimals || allowDecimals}
          onChange={event => handleChange(option.key, event.target.value)}
          autoFocus={focus}
        />
      ))}
      {children}
    </div>
  );
};

export default QuestionFormNumberMultiple;
